function applyDocumentHead(head) {
  document.documentElement.lang = head.lang;
  document.title = head.title;
  setMeta("description", head.description);
  for (const stale of document.head.querySelectorAll(
    'link[rel="canonical"], link[rel="alternate"][hreflang]'
  )) {
    stale.remove();
  }
  document.head.append(alternateLink("canonical", head.canonical));
  for (const { hreflang, href } of head.alternates) {
    document.head.append(alternateLink("alternate", href, hreflang));
  }
}
function alternateLink(rel, href, hreflang) {
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  if (hreflang !== void 0) link.hreflang = hreflang;
  link.dataset["charva"] = "";
  return link;
}
function setMeta(name, content) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  tag ??= document.head.appendChild(Object.assign(document.createElement("meta"), { name }));
  tag.content = content;
}

export { applyDocumentHead };
//# sourceMappingURL=head.js.map
//# sourceMappingURL=head.js.map